import mapActions from './mapActions';

export default mapActions('material', {
    fetchAll_url: data => `/api/material/entity/${data.id}`
});
